<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.ivu-mr,
.ivu-mr-16 {
  margin-right: 16px !important;
}
.ivu-mt,
.ivu-mt-16 {
  margin-top: 8px !important;
}
.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
.l-table-place {
  height: auto;
  max-height: 250px;
}
.flexs {
  display: flex;
}
// .flexs {
//   display: flex !important;
//     width:auto;
// }
.el-table tr {
  min-height: 44px;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <el-tabs ref="eltab" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in tab_list" :key="item.id" :label="item.name" :name="item.name">
        <div class="l-table-place">
          <div class="flex items-center justify-between ivu-mt">
            <div class="flex items-center">
              <p>场所类型：</p>
              <el-row>
                <el-button type="info" :class="{active:search_data.type==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type">{{item.name}}</el-button>
              </el-row>
            </div>
          </div>

          <div class="flex flex-warp">
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">隐患描述</p>
              <el-input placeholder="请输入隐患描述" v-model="search_data.name" class="input-with-select" style="width: 76%;">
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">网格名称</p>
              <el-input placeholder="请输入网格名称" v-model="search_data.network" class="input-with-select" style="width: 76%;">
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>

            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">所属街道</p>
              <div class="l-show-more-search">
                <el-select v-model="search_data.street_list" placeholder="全部" clearable @change="changes">
                  <el-option v-for="item in street_list" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">所属社区</p>
              <div class="l-show-more-search">
                <el-select v-model="search_data.community_id" placeholder="全部" clearable @change="changes">
                  <el-option v-for="item in community_list" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">日期</p>
              <div class="l-show-more-search" style="width: 76%;">
                <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
                </el-date-picker>
              </div>
            </div>
            <!-- <div class="flexs items-center ivu-mt ivu-mr">
              <l-auth-button type="info" auth="hidden_danger_analysis" @click="exportExcel" :loading="export_loading"> 导出EXCEL </l-auth-button>
            </div> -->
          </div>
        </div>
        <l-auth-button type="primary" auth="place_census_export_btn" icon="el-icon-download" @click="exportExcel">
          导出隐患
        </l-auth-button>
      </el-tab-pane>
    </el-tabs>

    <l-table v-show="activeName=='隐患描述'" :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="60"> </el-table-column>
      <el-table-column prop="danger" label="隐患描述" min-width="320"> </el-table-column>
      <el-table-column prop="hidden_count" label="隐患数" width="70"> </el-table-column>
      <el-table-column prop="rectify_count" label="已整改" width="70"> </el-table-column>
      <el-table-column prop="not_rectify_count" label="未整改" width="70"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="hidden_danger_analysis_info_btn" @click="showInfo(row.id)"><i class="el-icon-edit"></i>导出明细</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <l-table ref="analysis_table" v-show="activeName=='检查规范'" :data="data" v-loading="loading" row-key="id">
      <el-table-column fixed prop="index" label="序号" width="60"> </el-table-column>
      <el-table-column prop="name" label="验收标准" min-width="320"> </el-table-column>
      <el-table-column prop="hidden_count" label="隐患数" width="70"> </el-table-column>
      <el-table-column prop="rectify_count" label="已整改" width="70"> </el-table-column>
      <el-table-column prop="not_rectify_count" label="未整改" width="70"> </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column>
    </l-table>
    <!--分页-->
    <l-page v-show="activeName=='隐患描述'" :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--分页-->
    <l-page v-show="activeName=='检查规范'" :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>

    <!--详情-->
    <l-dialog :visible.sync="place_info_visible" title="场所信息" width="1600px">
      <l-place-info :visible.sync="place_info_visible" :id="place_id" is-info />
    </l-dialog>

  </el-card>
</template>
<script>
import { LEVEL } from '../rental/rental';
import { SUPERVISION } from "@/common/constants/place";
// import { PERTRIAL_STATE } from "./hidden";
// import { dateToStr,time_pick2 } from "@/utils/Fuc";
import PlaceInfo from "../place/Info.vue";
import Vue from "vue";
export default {
  components: {
    [PlaceInfo.name]: PlaceInfo,
  },
  data() {
    return {
      value1: '',
      data: [],
      count: 0,
      page: 1,
      activeName: "隐患描述",
      page_size: Vue.$_config.page.page_size,
      loading: false,
      export_loading: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      info_visible: false, //是否显示编辑
      edit_visible: false, //是否显示编辑
      place_info_visible: false,
      edit_id: 0,
      info_id: 0,
      place_id: 0,
      tab_list: [
        { "id": 1, "name": "隐患描述" },
        { "id": 2, "name": "检查规范" }
      ],

      SUPERVISION: SUPERVISION,
      LEVEL: LEVEL,
      //   PERTRIAL_STATE: PERTRIAL_STATE,

      //搜索
      search_visible: false,
      search_data: {
        start_time: '',
        end_time: '',
        street_id: "",
        community_id: "",
        danger: "",
        type: 2,
        code: 100,
      },
      rel_search_data: {},
      show_more_search: false,
      value2: '',
      place_type_list: [],
      community_list: [],
      street_list: [],
    };
  },
  computed: {
    columns() {
      let list = [];
      if (this.activeName == '隐患描述') {
        list = [
          {
            prop: "index",
            label: "序号",
            fixed: false,
            width: "60",
          },
          {
            prop: "danger",
            label: "隐患描述",
            fixed: false,
            width: "700",
          },
          {
            prop: "hidden_count",
            label: "隐患数",
            fixed: false,
            Width: "60",
          },

          {
            prop: "rectify_count",
            label: "已整改",
            fixed: false,
            Width: "60",
          },
          {
            prop: "not_rectify_count",
            label: "未整改",
            fixed: false,
            Width: "60",
          },
        ];
      } else {
        list = [
          {
            prop: "index",
            label: "序号",
            fixed: false,
            width: "60",
          },
          {
            prop: "name",
            label: "验收标准",
            fixed: false,
            width: "700",
          },
          {
            prop: "hidden_count",
            label: "隐患数",
            fixed: false,
            Width: "60",
          },

          {
            prop: "rectify_count",
            label: "已整改",
            fixed: false,
            Width: "60",
          },
          {
            prop: "not_rectify_count",
            label: "未整改",
            fixed: false,
            Width: "60",
          },
        ];
      }
      return list;

    },
  },

  watch: {

    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    },
    activeName() {
      this.$refs.analysis_table._data.table_height = window.innerHeight - this.$refs.eltab.$el.offsetHeight - 175 - 16;
    }
  },

  mounted() {
    this.getList();
    this.getdata();
  },

  methods: {
    //tab点击
    handleClick() {
      if (this.activeName == '隐患描述') {
        this.search_data.code = 100;
      } else {
        this.search_data.code = 200;
      }
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //导出
    exportExcel() {
      this.export_loading = true;
      this.$_invoke('hiddenAnalysis_export', {
        page: 1,
        page_size: 999999,
        ...this.search_data
      })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    },
    //通过类型筛选
    placetype(id) {
      this.search_data.type = id;
      this.rel_search_data = this.search_data;
      this.getList();
      this.getdata();
    },
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("hiddenAnalysis_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //获取筛选数据
    getdata() {
      this.loading = true;
      this.$_invoke("hiddenAnalysis_getSearchData", {
        ...this.search_data,
      })
        .then((ret) => {
          this.street_list = ret.street_list;
          this.place_type_list = ret.place_type_list;
          this.community_list = ret.community_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //
    placeInfo(id) {
      this.place_id = id;
      this.$nextTick(() => {
        this.place_info_visible = true;
      });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //导出详情 
    showInfo(id) {
      this.export_loading = true;
      this.$_invoke('hiddenAnalysis_detailsExport', {
        check_specs_proposal_id: id
      })
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    },

    //默认时间
    // onfocus() {
    //   if (this.value2 == "" || !this.value2) {
    //     this.value2 = time_pick2();
    //   }
    // },
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
  },
};
</script>
